export const normalizeTurkishText = (text) => {
  if (!text) return "";

  const normalizedText = text.toLocaleLowerCase("tr-TR").replace(
    /ö|ç|ş|ı|ğ|ü/g,
    (match) =>
      ({
        ö: "o",
        ç: "c",
        ş: "s",
        ı: "i",
        ğ: "g",
        ü: "u",
      }[match])
  );

  return normalizedText.replace(/[^a-z0-9]+/gi, "-");
};
